import type { RemixHiddenOptionKind } from '@atlassian/malleable-ui-components/common/types';

import { expVal } from '@confluence/feature-experiments';
import { usePageSpaceKey } from '@confluence/page-context';
import { useSpaceDetail } from '@confluence/space-utils/entry-points/useSpaceDetail.ts';

const HIDDEN_DIAGRAM_OPTIONS: readonly RemixHiddenOptionKind[] = ['diagram'];
const NO_HIDDEN_OPTIONS: readonly RemixHiddenOptionKind[] = [];

/**
 * The "diagram" option is only relevant to spaces that
 * have Whiteboards enabled (diagrams are finalized as whiteboards). When a space
 * does not have Whiteboards enabled, the diagram option is hidden from every
 * Remix picker entrypoint (in-editor picker, object-sidebar popup, and the
 * view-mode renderer).
 */
export const useShouldHideDiagramRemixOption = (): readonly RemixHiddenOptionKind[] => {
	const [spaceKey] = usePageSpaceKey();
	const { data: spaceDetail } = useSpaceDetail(spaceKey, {
		includeSpaceTypeSettings: true,
	});

	const isWhiteboardsEnabled =
		spaceDetail?.typeSettings?.enabledContentTypes?.isWhiteboardsEnabled ?? false;

	// Only hide the diagram option when whiteboards are unavailable for the space
	if (!isWhiteboardsEnabled && expVal('cc_maui_polish_changes_batch_2', 'isEnabled', false)) {
		return HIDDEN_DIAGRAM_OPTIONS;
	}

	return NO_HIDDEN_OPTIONS;
};
